<template>
    <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen p-4">
        <div class="bg-white w-full max-w-md rounded-lg shadow-xl p-6 relative">
            <button
                @click="closeModal"
                class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          <h3 class="text-2xl font-semibold text-gray-800 mb-4">
            Contact Candidate
          </h3>
            <div v-if="application">
                 <p class="text-gray-700 mb-2">
                     These are the contact instructions:  <br>
                     {{ contactInstructions }}
                 </p>
              </div>
              <div v-else>
               <p class="text-gray-700 mb-2">Candidate information not available.</p>
             </div>

        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    props: {
        isOpen: Boolean,
      application: Object
    },
      data(){
          return {
            contactInstructions: "Contact the candidate by phone or email"
         }
      },
    methods: {
      closeModal() {
        this.$emit("close");
      },
    },
  };
  </script>